import React, { useEffect, useState } from 'react';
import { Formik, Form, useFormikContext } from 'formik';
import FlatDetails from './FlatDetailsJson';
import {
  getLeadProertyDetails,
  saveLeadPropertyDetails
} from '../../../common/constants/api';
import PopUp from '../../../common/components/PopUp/PopUp';
import * as _ from 'lodash';
import FlapCostEstimation from '../../../common/components/CommonCostEstimate/FlatCostEstimate';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
const CostAndFlatDetails = () => {
  // selectedSubPropertType, eg-Flat, individual house...
  // selectedPropertType, eg-new purchase, BT ...
  // propertyConstructionStatus, underdevelop , constructed fully ..

  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    handleSubmit,
    isSubmitting,
    setFieldTouched
  } = useFormikContext();
  const [step, setStep] = useState('');
  const [canShowCost, setShowCost] = useState(values.constructionStatus());
  const [property, setProperty] = useState(values.selectedProperty());
  const [subproperty, setSubProperty] = useState(values.selectedSubProperty());

  useEffect(() => {
    if (property == 'Balance Transfer' && subproperty == 'Plot') {
      setShowCost(true);
    }
    if (
      property == 'Renovation/Improvement' ||
      property == 'Self Construction' ||
      property == 'New Purchase' ||
      property == 'Resale'
    ) {
      setShowCost(true);
    }
  }, []);

  useEffect(() => {
    if (step == 'PropertyDetailDone' && !canShowCost) {
      handleSubmit();
    }
  }, [step]);

  return (
    <div className="w-full">
      <div className="w-full my-5">
        <FlatDetails value={values} seStep={setStep} />
      </div>
      {step == 'PropertyDetailDone' && canShowCost ? (
        <div className="w-full ">
          <FlapCostEstimation value={values} detailSubmit={handleSubmit} />
        </div>
      ) : null}
    </div>
  );
};

export default CostAndFlatDetails;
